import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "z-20 flex-center"
};
const _hoisted_2 = {
  key: 0,
  class: "mr-2 flex-center"
};
const _hoisted_3 = {
  class: "text-xl flex items-center"
};
const _hoisted_4 = {
  key: 0,
  class: "border-l ml-2 pl-2 flex items-center"
};
import Icon from "@/modules/vue/components/Icon.vue";
import { generateColorMap } from "@/modules/vue/utils";
import ConfirmationButton from "@/modules/vue/components/ConfirmationButton.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'GateButtonConfirmation',
  props: {
    color: null,
    icon: null,
    noReset: {
      type: Boolean
    },
    noConfirm: {
      type: Boolean
    }
  },
  emits: ['confirm'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const progressMap = generateColorMap({
      bg: 200
    });
    const onClick = () => emit('confirm');
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(ConfirmationButton, {
        "no-reset": __props.noReset,
        "no-confirm": __props.noConfirm
      }, {
        default: _withCtx(({
          confirmed,
          type,
          label,
          attrs
        }) => [_createVNode(_component_NButton, _mergeProps(_ctx.$attrs, {
          color: _ctx.ColorValue[__props.color][600],
          secondary: "",
          onClick: onClick
        }), {
          default: _withCtx(() => [!confirmed ? (_openBlock(), _createElementBlock("div", _hoisted_1, [__props.icon ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "icon", {}, () => [_createVNode(Icon, {
            icon: __props.icon
          }, null, 8, ["icon"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "default"), _ctx.$slots.label ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_renderSlot(_ctx.$slots, "label")])) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString(label), 1)], 64))]),
          _: 2
        }, 1040, ["color"])]),
        _: 3
      }, 8, ["no-reset", "no-confirm"]);
    };
  }
});